import React, {useCallback} from 'react';
import styled from 'styled-components';

function TreeTrigger(props) {
	const {children, isOpened, setIsOpened, disabled, onClick} = props;

	const handleOnClick = useCallback(
		(event) => {
			if (!disabled) {
				let icon = event.currentTarget.querySelector('.tree-icon');
				if (!icon.contains(event.target)) {
					if (onClick) {
						onClick(event);
					}
				}

				if (!event.isDefaultPrevented()) {
					setIsOpened(!isOpened);
				}
			}
		},
		[isOpened, setIsOpened, disabled, onClick]
	);

	return (
		<StyledTreeTrigger className="tree-trigger" onClick={handleOnClick}>
			{children}
		</StyledTreeTrigger>
	);
}

const StyledTreeTrigger = styled.section`
	display: flex;
`;

export default TreeTrigger;
